import { useState, useEffect } from "react";
import DashboardLayout from "../../../../Layout/DashboardLayout";
import Header from "../Components/Header";
import { Modal, Pagination, Table, TablePaginationConfig } from "antd";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "../Components/SearchBox";
import { useGetProductsQuery } from "../../../../hooks/ProductsManagement/useGetProductsQuery";
import Loader from "../../../../Components/Loader";
import Button from "Components/Button";
import { useDeleteProductsMutation } from "hooks/ProductsManagement/useDeleteProductsMutation";
import { queryClient } from "services/queryClient";
import { PlusIcon } from "Layout/icons";
import KoboConverter from "Components/KoboConverter";

const Catalog = () => {
  // Retrieve active state from localStorage or default to 'list'
  const [active, setActive] = useState(() => {
    return localStorage.getItem("catalogView") || "list";
  });

  const [page, setPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const [search, setSearch] = useState("");
  const [action, setAction] = useState("");
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (newPagination: TablePaginationConfig) => {
    setPagination({
      ...pagination,
      current: newPagination.current ?? 1,
      pageSize: newPagination.pageSize ?? 3,
    });
  };

  const { data, isPending } = useGetProductsQuery({ search });
  const navigate = useNavigate();

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Persist active state in localStorage
  useEffect(() => {
    localStorage.setItem("catalogView", active);
  }, [active]);

  const { mutateAsync, isPending: isDeletingProduct } =
    useDeleteProductsMutation();

  const openDeleModal = ({ action }: { action: string }) => {
    setIsDeleteModalOpen(true);
    setAction(action);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteProduct = () => {
    mutateAsync(rowSelection?.selectedRowKeys, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["useGetProductsQuery"],
        });
        setIsDeleteModalOpen(false);
        setSelectedRowKeys([]);
      },
    });
  };

  const blank = require("../../../../assets/blank.png");

  return (
    <DashboardLayout
      title="Products Catalog"
      back={false}
      right={
        <div className="flex gap-3 items-center">
          <SearchBox search={search} setSearch={setSearch} />
          <Link
            to="/product-management/add-to-category"
            className="p-3 border height-auto rounded-[10px] text-[14px]"
          >
            Add Product to Category
          </Link>
        </div>
      }
    >
      {/* <div className="flex gap-3 border-b-[1px] border-[#eeeeee] mb-3 py-3 justify-end pr-4">
        <button className="rounded-md bg-orange text-white p-3 flex gap-1">
          <Plus />
          View Credit History
        </button>
        <button className="rounded-md bg-[#F3F3F3] text-[#414141] p-3 flex gap-1">
          <Plus /> Create New Category
        </button>
      </div> */}
      <Header
        active={active}
        setActive={setActive}
        count={data?.data?.meta?.totalDocs}
      />
      {isPending ? (
        <Loader />
      ) : active === "box" ? (
        <div className="grid gap-x-4 grid-cols-4 ml-[20px] mr-[14px] mt-[20px]">
          {data?.data?.docs?.map(
            ({
              id,
              name,
              images,
              unitPrice,
              bulkPrice,
            }: {
              id: string;
              name: string;
              images: string[];
              unitPrice: number;
              bulkPrice: number;
            }) => (
              <span className="mb-6" key={id}>
                {/* <img
                  src={blank}
                  alt="product"
                  className="w-full h-[300px] border-[1px] border-[#eeeeee]"
                /> */}
                <h3 className="mt-[15px] font-bold">{name}</h3>
                <p className="mb-1">
                  <KoboConverter amount={unitPrice ? unitPrice : 0} />{" "}
                  <span className="text-ash">min price</span>
                </p>
                <p className="">
                  <KoboConverter amount={bulkPrice ? bulkPrice : 0} />{" "}
                  <span className="text-ash">bulk price</span>
                </p>
              </span>
            )
          )}
        </div>
      ) : (
        <div>
          {rowSelection?.selectedRowKeys?.length > 0 && (
            <div className="flex justify-between items-center px-5 mt-3">
              <button
                onClick={() => openDeleModal({ action: "delete" })}
                className="flex gap-2 items-center bg-orange p-2 rounded-md text-white text-[12px] font-bold"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                    clipRule="evenodd"
                  />
                </svg>
                Delete Product
                {rowSelection?.selectedRowKeys.length > 1 ? "s" : ""}
              </button>
              <button
                onClick={() => openDeleModal({ action: "add" })}
                className="flex gap-2 items-center bg-orange p-2 rounded-md text-white text-[12px] font-bold"
              >
                <PlusIcon />
                Add Product
                {rowSelection?.selectedRowKeys.length > 1 ? "s" : ""} to
                Category
              </button>
            </div>
          )}
          <Table
            rowKey="id"
            dataSource={data?.data?.docs}
            columns={columns}
            pagination={false}
            onChange={handleTableChange}
            rowSelection={rowSelection}
            scroll={{ y: "50vh" }}
            className="pl-[19px] pr-[40px] manrope mt-[20px]"
            onRow={(record: any) => ({
              onClick: () => navigate(`/product-management/${record?.id}`),
            })}
          />

          <Pagination
            size="small"
            current={page}
            pageSize={data?.data?.meta?.limit}
            className="mt-4"
            total={data?.data?.meta?.totalDocs}
            onChange={setPage}
          />
          <Modal
            // title="Delete Categories"
            title={
              action === "delete"
                ? `Delete ${rowSelection?.selectedRowKeys.length} product${
                    rowSelection?.selectedRowKeys.length > 1 ? "s" : ""
                  }`
                : `Add ${rowSelection?.selectedRowKeys.length} product${
                    rowSelection?.selectedRowKeys.length > 1 ? "s" : ""
                  } to category`
            }
            open={isDeleteModalOpen}
            onCancel={closeDeleteModal}
            footer={null}
          >
            {action === "delete" && (
              <>
                <h3 className="text-[16px] maanrope mb-4">
                  Confirm that you'd like to delete the selected product
                  {rowSelection?.selectedRowKeys.length > 1 ? "s" : ""}
                </h3>

                <Button
                  label="Delete"
                  isLoading={isDeletingProduct}
                  className="text-white bg-[#f00] p-[12px] font-bold rounded-md ease-in-out duration-300"
                  onClick={() => {
                    handleDeleteProduct();
                  }}
                />
              </>
            )}
            {action === "add" && (
              <>
                <h3 className="text-[16px] maanrope mb-4">
                  Select the category you'd like to add the selected product
                  {rowSelection?.selectedRowKeys.length > 1 ? "s" : ""}
                </h3>

                <Button
                  label="Delete"
                  isLoading={isDeletingProduct}
                  className="text-white bg-[#f00] p-[12px] font-bold rounded-md ease-in-out duration-300"
                  onClick={() => {
                    handleDeleteProduct();
                  }}
                />
              </>
            )}
          </Modal>
        </div>
      )}
    </DashboardLayout>
  );
};

export default Catalog;

const columns = [
  // {
  //   title: 'Product ID',
  //   dataIndex: 'id',
  //   key: 'id',
  //   render: (id: string) => (
  //     <Link
  //       to={`/product-management/${id}`}
  //       className="underline text-green font-bold truncate w-[10px]"
  //     >
  //       #{id}
  //     </Link>
  //   ),
  // },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (name: string, record: { images: string[] }) => (
      <span className="flex gap-3 items-center">
        <img
          src={
            record.images[0].length === 1 ? record.images[0] : record.images[0]
          }
          alt="Product"
          className="rounded-[2px] h-[30px] w-[30px]"
        />
        {name}
      </span>
    ),
  },
  {
    title: "Unit Price",
    dataIndex: "unitPrice",
    key: "unitPrice",
    render: (unitPrice: any, record: any) => (
      <span>
        <KoboConverter amount={unitPrice} />
        <span className="text-ash">/{record?.unitStockMeasurement}</span>
      </span>
    ),
  },
  {
    title: "Bulk Price",
    dataIndex: "bulkPrice",
    key: "bulkPrice",
    render: (bulkPrice: any, record: any) => (
      <span>
        <KoboConverter amount={bulkPrice} />
        <span className="text-ash">/{record?.bulkStockMeasurement}</span>
      </span>
    ),
  },
  // {
  //   title: "In Stock",
  //   dataIndex: "bulkTotalStock",
  //   key: "bulkTotalStock",
  // },
  {
    title: "Date Added",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt: string) => {
      const date = new Date(createdAt);
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    },
  },
];
